import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class RestringirMccProdutoClienteCartaoService {

  constructor(private http:HttpClient, private httpService:HttpService) { }

  // salvaRestricoes(data: any, successHandle: Function, errorHandle: Function) {
  //   this.httpService.doPost('/mcc/lockAccountProduct',data, successHandle, errorHandle);
  // }

  buscaCartoes(data: any, successHandle: Function, errorHandle: Function) {
    this.httpService.doGet('/mcc/accountProductCards',data, successHandle, errorHandle);
  }

}
